module.exports = require("./fr-BL.d.ts");